import { PicklistOption } from "../blocks/fields/PicklistField.types";

/** One candidate record, with whatever else the service sent for it, e.g. `OpponentId`. */
export type LookupRecord = PicklistOption & Record<string, unknown>;

/**
 * Narrows a lookup's candidates given the record being edited - only one opponent's
 * fixtures, say. Sees any extra fields the service sent with each candidate.
 */
export type LookupOptionFilter = (
  options: LookupRecord[],
  record: Record<string, unknown>
) => LookupRecord[];

/** Filters a lookup can name, addressed by key so page config stays serialisable. */
export const lookupOptionFilters: Record<string, LookupOptionFilter> = {};

/** Filled from each record definition's own filters, by recordDefinitions. */
export function registerLookupOptionFilters(
  filters: Record<string, LookupOptionFilter> | undefined
) {
  Object.assign(lookupOptionFilters, filters);
}

/** Undefined for an unknown name, so an older build offers every candidate. */
export function getLookupOptionFilter(name: string | undefined) {
  return name ? lookupOptionFilters[name] : undefined;
}
